import React from 'react';
import styled from 'styled-components';
import video from './videos/builder.mp4';
import backgroundImage from './images/builderSectionBg.png';
import horizontallyCenteredSection from '../../../components/styles/horizontallyCenteredSection';

const BuilderSectionStyles = styled.section`
  padding-top: 5rem;
  padding-bottom: 5rem;
  background-color: var(--color-fluor-orange);
  background-image: url('${backgroundImage}');
  position: relative;

  .video-wrapper {
    max-width: 100%;
    background-color: var(--color-black);

    .video-label {
      display: flex;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      padding: 1rem;
      position: absolute;
      align-items: center;
      justify-content: center;
      color: var(--color-white);
      font-size: 1.5rem;
      text-align: center;
      z-index: var(--z-index-low);
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
    }

    video {
      max-width: 100%;
      opacity: 1;
      transition: opacity 0.2s ease-in-out;
    }

    &:hover {
      .video-label {
        opacity: 1;
      }
      video {
        opacity: 0.2;
      }
    }
  }

  @media (min-width: 768px) {
    ${horizontallyCenteredSection}
    padding-top: 7rem;
    padding-bottom: 7rem;

    .video-wrapper {
      max-width: 66%;

      .video-label {
        padding-top: 7rem;
        padding-bottom: 7rem;
        left: 5%;
        max-width: calc(66% - 7%);
      }
    }
  }
`;

export default function BuilderSection() {
  return (
    <BuilderSectionStyles>
      <div className="video-wrapper">
        <a href="/builder">
          <div className="video-label">
            Click here to create your Artema Diana now
          </div>
          <video muted autoPlay loop>
            <source src={video} type="video/mp4" />
          </video>
        </a>
      </div>
    </BuilderSectionStyles>
  );
}
